import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import ShowcaseContext from '~/context/vdp/ShowcaseContext';
import { getVehicleId, getVehicleStockNumber } from '~/selectors';
import ErrorWithContext from '~/server-utils/ErrorWithContext';
import fetchSpinnerData from '~/services/vdp/fetchSpinnerData';
import useSelector from '~/store/useSelector';
import generateErrorLogger, { logError } from '~/utilities/errorHandlers';

export default function useGetSpinnerData() {
  const { enableAutoShowcase } = useConfiguration();
  const { setActiveCategory, setIsMissingCategories, spinnerData } =
    useContext(ShowcaseContext);
  const stockNumber = useSelector(getVehicleStockNumber);
  const vehicleId = useSelector(getVehicleId);

  const { setData, setLoading, setError } = spinnerData;

  useEffectWithController(
    controller => {
      if (!enableAutoShowcase) return;

      setLoading();

      fetchSpinnerData(stockNumber, controller)
        .then(v => {
          const isMissingCategories =
            !v.categories || v.categories.length === 0;

          if (isMissingCategories) {
            setIsMissingCategories(true);
            logError(
              new ErrorWithContext('Missing category data', { vehicleId })
            );
          }

          const hasMissingNarratives =
            !isMissingCategories && v.categories.some(c => !c.narrative);

          if (hasMissingNarratives) {
            logError(
              new ErrorWithContext('Missing narrative data', { vehicleId })
            );
          }

          setData(v);
        })
        .catch(() => {
          setIsMissingCategories(true);
          generateErrorLogger('Get spinner data', undefined, {
            callback: setError
          });
        });
    },
    [
      enableAutoShowcase,
      setActiveCategory,
      setData,
      setError,
      setIsMissingCategories,
      setLoading,
      stockNumber,
      vehicleId
    ]
  );
}
